export default {
    "login_text1": "Log in",
    "login_text2": "BoardSight",
    "login_text3": "ADMIN CONSOLE",
    "login_text4": "Sign In",
    "login_text5": "Username or Email",
    "login_text6": "Enter username or email",
    "login_text7": "Password",
    "login_text8": "Enter password",
    "login_text9": "OTP",
    "login_text10": "Enter OTP",
    "login_text11": "Sending ..",
    "login_text12": "Retry after ",
    "login_text13": " seconds",
    "login_text14": "Send OTP",
    "login_text15": "Login with Deloitte Account",
    "login_text16": "Activate Account",
    "login_text17": "Set Password",
    "login_text18": "Change Password",
    "login_text19": "Old password",
    "login_text20": "Enter old password",
    "login_text21": "New Password",
    "login_text22": "Enter new password",
    "login_text23": "Confirm new password",
    "login_text24": "The 'new password' and the 'confirmed new password' do not match",
    "login_text25": "Your password has expired. Please change your password and log in again.",
    "login_text26": "Do you want to logout?",
    "login_text27": "Please select the role to log in:",
    "login_text28": "This field is required",
    "login_text29": "Old password is required",
    "login_text30": "New password is required",
    "login_text32": "Login successful",
    "login_text33": "Logout successful",
    "login_text31": "Confirm new password is required",
    "login_text34": "Testing Environment",
    "login_text35": "Forgot Password",
    "login_text36": "Obtain the OTP then set a new password.",
    "login_text37": "Password must be at least 10 characters and include uppercase, lowercase, a number, and a special character. Avoid consecutive or repeating characters and common words.",
    "login_text38": "If the account exists, an OTP has been sent to the registered email.",
    "login_text39": "Password reset successful. Please log in again.",
    "validation_required": "{field} is required",
    "validation_required_input": "Please enter {field}",
    "field_nickName": "Nick name",
    "field_userName": "User name",
    "field_email": "Email",
    "field_title": "Title",
    "field_tenure": "Tenure (Year)",
    "field_age": "Age",
    "field_moduleVersion": "Version",
    "field_moduleName": "Module name (Chinese)",
    "field_moduleNameEn": "Module name (English)",
    "field_description": "Description (Chinese)",
    "field_descriptionEn": "Description (English)",
    "field_type": "Type",
    "field_participantScope": "Participant scope",
    "field_package": "Package",
    "field_paymentStatus": "Payment status",
    "field_questionVersion": "Version",
    "field_questionType": "Question type",
    "field_questionTitle": "Question title",
    "field_questionTitleEn": "Question title (English)",
    "field_companyName": "Company name",
    "field_companyNameEn": "Company name (English)",
    "field_stockCode": "Stock code",
    "field_entityType": "Entity type",
    "field_industry": "Industry",
    "field_sector": "Sector",
    "field_yearEnd": "Year end",
    "field_address": "Address",
    "field_region": "Region",
    "field_spName": "Package name",
    "field_spNameEn": "Package name (English)",
    "field_profFee": "Professional fee",
    "field_orderNum": "Order",
    "field_isDirector": "Director",
    "field_isLead": "Lead",
    "field_post": "Post",
    "field_role": "Role",
    "field_sex": "Gender",
    "field_relevantQuestion": "Relevant question",
    "field_owner": "Owner",
    "field_shortObservationName": "Short observation name",
    "field_observationDetails": "Observation details",
    "field_actionTitle": "Action title",
    "field_actionDetails": "Action details",
    "field_targetDate": "Target date",
    "field_status": "Status",
    "field_launchDate": "Launch date",
    "field_deadlineDate": "Deadline date",
    "field_autoReminders": "Auto reminders",
    "field_content": "Content",
    "field_password": "Password",


    "footer_text1": "Copyright reserved by Deloitte Touche Tohmatsu CPA Limited (Hong Kong, China), Deloitte Touche Tohmatsu CPA Limited (Macau, China), and Deloitte Touche Tohmatsu CPA Limited (Special General Partnership) (Mainland China).",
    "footer_text2": "Deloitte refers collectively to Deloitte Touche Tohmatsu Limited, a private company limited by guarantee organized under English law (hereinafter referred to as \"DTTL\"), as well as one or more of its member firms and their related entities. DTTL and each member firm are legally separate and independent entities. DTTL (also known as \"Deloitte Global\") does not provide services to clients. Please refer to ",
    "footer_text3": "About Deloitte",
    "footer_text4": " to learn more about Deloitte Touche Tohmatsu Limited and its member firms.",

    "open": "open",
    "menu1": "Engagement Management",
    "menu2": "Board Evaluation",
    "menu3": "Home",
    "menu4": "Engagement Management",
    "menu5": "Package Management",
    "menu6": "Module Management",
    "menu7": "Question Management",
    "menu8": "Security & Access",
    "menu9": "System Management",
    "menu10": "AI Agent",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "save": "Save",
    "index": "Index",
    "actionUp": "Action",
    "confirmationReminder": "Confirmation",
    "true": "True",
    "false": "False",
    "pleaseSelect": "Please select",
    "placeholder_select": "Select",
    "placeholder_select_version": "Select version",
    "placeholder_select_role": "Select role",
    "placeholder_search_modules": "Search Modules",
    "placeholder_search_question": "Search questions",
    "placeholder_search_user": "Search by name, email, organization",
    "placeholder_select_deadline": "Select Deadline",
    "placeholder_type_answer": "Type your answer...",
    "placeholder_gap_ref": "e.g. GAP-H18-01",
    "operation-successfully": "Operation successful",
    "operationFail": "Operation failed",
    "complete": "Complete",
    "inProgress": "In Progress",
    "notStarted": "Not Started",
    "reviewing": "Reviewing",
    "generateReport": "Generate Report",
    "tobeReport": "Report to be generated",
    "yes": "Yes",
    "no": "No",
    "refreshCache": "Refresh Cache",
    "dataDictionary": "Data Dictionary",
    "privacyContentTitle": "Privacy Notice Content",
    "privacyContentVersion": "Version",
    "privacyContentLastUpdated": "Last updated",
    "privacyContentEdit": "Edit",
    "privacyContentEditDialogTitle": "Edit Privacy Notice Content",
    "privacyContentVersionPlaceholder": "e.g. v1.0",
    "privacyContentVersionTip": "Changing the version will require all client admin and participant users to review and accept the privacy notice again.",
    "privacyContentEnglish": "English",
    "privacyContentChinese": "Chinese",
    "privacyContentTitleEn": "Title (English)",
    "privacyContentTitleCn": "Title (Chinese)",
    "privacyContentContentEn": "Content (English)",
    "privacyContentContentCn": "Content (Chinese)",
    "privacyContentVersionChangedWarning": "Privacy notice version changed. All client admin and participant users must accept again.",
    "field_privacyVersion": "Version",
    "field_privacyTitleEn": "English title",
    "field_privacyTitleCn": "Chinese title",
    "field_privacyContentEn": "English content",
    "field_privacyContentCn": "Chinese content",
    "privacyConsentDialogTitle": "Privacy Notice and Consent",
    "privacyConsentReadCheckbox": "I confirm that I have read the privacy notice.",
    "privacyConsentPersonalInfoCheckbox": "I consent to the collection, use, and processing of my personal information for BoardSight service purpose.",
    "privacyConsentLogoutPrompt": "You must confirm both privacy statements before entering the system. Do you want to log out now?",
    "privacyConsentDefaultTitle": "Privacy Notice",

    "notFoundText1": "404 - Page not found",
    "notFoundText2": "The page you are visiting does not exist",
    "notFoundText3": "Return to homepage",

    "errorCodeText1": "Authentication failed, unable to access system resources",
    "errorCodeText2": "You do not have permission for the current operation",
    "errorCodeText3": "The accessed resource does not exist",
    "errorCodeText4": "System unknown error, please report to the administrator",

    "system_text1": "The requested data size exceeds the allowed 5M limit, and cannot undergo anti-duplicate submission verification.",
    "system_text2": "Data is being processed, please do not submit repeatedly",
    "system_text3": "Your login status has expired. You can either stay on this page or log in again.",
    "system_text4": "Log in again",
    "system_text5": "Cancel",
    "system_text6": "Invalid session, or session has expired. Please log in again.",
    "system_text7": "Backend interface connection exception",
    "system_text8": "System interface request timed out",
    "system_text9": "System Interface",
    "system_text10": "Abnormal",
    "system_text11": "System prompt",
    "system_text12": "Loading...",

    "header_text1": "BoardSight",
    "header_text2": "Sharper Insight, Smarter Governance",
    "header_text3": "Change Password",
    "header_text4": "Old Password",
    "header_text5": "New Password",
    "header_text6": "Company",
    "header_text7": "Switch company",

    "page1-text1": "Client Information",
    "page1-text2": "New Client",
    "page1-text3": "Entity name",
    "page1-text4": "Stock code",
    "page1-text5": "Year end",
    "page1-text6": "Create by",
    "page1-text7": "Create time",
    "page1-text8": "Status",
    "page1-text9": "Open",

    "page2-text1": "Engagement Information",
    "page2-text2": "New Engagement",
    "page2-text4": "Edit Engagement",
    "page2-text5": "All",
    "page2-text6": "Pending Approval",
    "page2-text7": "Active",
    "page2-text8": "Expired / Archived",
    "page2-text9": "Engagement",
    "page2-text10": "Client",
    "page2-text11": "PIC",
    "page2-text12": "Package",
    "page2-text13": "Fee",
    "page2-text14": "Payment",
    "page2-text15": "Please confirm that you want to generate the report？",

    "page3-text1": "Create New Client",
    "page3-text2": "Client Information",
    "page3-text3": "Edit Client",
    "page3-text4": "Client Entity Details",
    "page3-text5": "Entity Name (Chinese)",
    "page3-text6": "Entity Name (English)",
    "page3-text7": "Stock Code",
    "page3-text8": "Entity Type",
    "page3-text9": "Industry",
    "page3-text9a": "Sector",
    "page3-text10": "Region",
    "page3-text11": "Year End",
    "page3-text12": "Address",
    "page3-text13": "Contact Name",
    "page3-text14": "Contact Title",
    "page3-text15": "Contact Email",
    "page3-text16": "HK Listed Issuer",
    "page3-text17": "Private Company",
    "page3-text18": "NGO / Statutory Body",
    "industry_consumer": "Consumer",
    "industry_energy_resources_industrials": "Energy, Resources and Industrials",
    "industry_financial_services": "Financial Services",
    "industry_government_public_services": "Government and Public Services",
    "industry_life_sciences_health_care": "Life Sciences and Health Care",
    "industry_technology_media_telecom": "Technology, Media and Telecom",
    "sector_automotive": "Automotive",
    "sector_consumer_products": "Consumer Products",
    "sector_retail_wholesale_distribution": "Retail, Wholesale and Distribution",
    "sector_transportation_hospitality_services": "Transportation, Hospitality and Services",
    "sector_energy_chemicals": "Energy & Chemicals",
    "sector_industrial_products_construction": "Industrial Products and Construction",
    "sector_mining_metals": "Mining and Metals",
    "sector_power_utilities_renewables": "Power, Utilities and Renewables",
    "sector_banking_capital_markets": "Banking and Capital Markets",
    "sector_insurance": "Insurance",
    "sector_investment_management": "Investment Management",
    "sector_real_estate": "Real Estate",
    "sector_central_government": "Central Government",
    "sector_defense_security_justice": "Defense, Security and Justice",
    "sector_health_human_services": "Health and Human Services",
    "sector_infrastructure_transport_regional_government": "Infrastructure, Transport and Regional Government",
    "sector_health_care": "Health Care",
    "sector_life_sciences": "Life Sciences",
    "sector_technology": "Technology",
    "sector_telecom_media_entertainment": "Telecom, Media and Entertainment",
    "page3-text24": "Client Key Contact",
    "page3-text25": "Manager in Charge",
    "page3-text26": "Search and add admin. Please create admin under Security & Access if admin doesn't exist.",
    "page3-text27": "Search by name or email",
    "page3-text28": "You cannot remove yourself as Manager in Charge",

    "page4-text1": "Service Package & Scope",
    "page4-text2": "Package",
    "page4-text3": "Service Fee (HKD)",
    "page4-text4": "Payment Status",
    "page4-text5": "Manager Confirmation:",
    "page4-text6": "I confirm I hold the rank of Manager or above. I have verified the entity details against internal conflict checks and authorize the creation of this engagement record.",
    "page4-text7": "Pending Invoice",
    "page4-text8": "Invoiced",
    "page4-text9": "Paid",

    "page5-text1": "Instructions (Chinese)",
    "page5-text2": "Instructions (English)",

    "page6-text1": "Module Management",
    "page6-text2": "Package Management",
    "page6-text3": "Module In Package",
    "page6-text4": "Last modified by ",
    "page6-text5": "on",
    "page6-text6": "Duplicate Package",
    "page6-text7": "Preview",
    "page6-text8": "Release Package",
    "page6-text9": "Unbind Module",
    "page6-text10": "All Evaluation Modules",
    "page6-text11": "Click \"Edit\" to manage questions",
    "page6-text12": "Add Module",
    "page6-text13": "New Module",
    "page6-text14": "Total Modules",
    "page6-text15": "Total Questions",
    "page6-text16": "Module name",
    "page6-text17": "Questions",
    "page6-text18": "Updated by",
    "page6-text19": "Date",
    "page6-text20": "Latest",
    "page6-text21": "Release",
    "page6-text22": "Version",
    "page6-text23": "Questions",
    "page6-text24": "Confirmation",
    "page6-text25": "Please confirm that you want to add this module？",
    "page6-text26": "Please confirm that you want to release this package？",
    "page6-text27": "Please confirm that you want to Unbind this module？",

    "page7-text1": "Create New Module",
    "page7-text2": "Engagement Information",
    "page7-text3": "Edit Engagement",
    "page7-text4": "New Version",
    "page7-text5": "Module Version",
    "page7-text6": "Module Name (Chinese)",
    "page7-text7": "Module Name (English)",
    "page7-text8": "Description (Chinese)",
    "page7-text9": "Description (English)",
    "page7-text10": "Type",
    "page7-text11": "Is Director",
    "page7-text12": "Time Estimate",
    "page7-text13": "min",
    "page7-text14": "N/A",
    "page7-text15": "Committee",
    "page7-text16": "STK",
    "page7-text17": "360",
    "page7-text18": "All",
    "page7-text19": "Director",
    "page7-text20": "Non-director",

    "page8-text1": "Release Modules",
    "page8-text2": "Click \"Edit\" to manage questions",
    "page8-text3": "Search",

    "page9-text1": "Icon",

    "page10-text1": "Create New Package",
    "page10-text2": "Package Information",
    "page10-text3": "Edit Package",
    "page10-text4": "New Version",
    "page10-text5": "Package Version",
    "page10-text6": "Package Name (Chinese)",
    "page10-text7": "Package Name (English)",
    "page10-text8": "Description (Chinese)",
    "page10-text9": "Description (English)",
    "page10-text10": "Service Fee (HKD)",
    "page10-text14": "CG Disclosure Template",
    "page10-text11": "Order Number",
    "page10-text12": "Enhanced Documentation Review",
    "page10-text13": "Enable",

    "page11-text1": "Package Management",
    "page11-text2": "New Package",
    "page11-text3": "All",
    "page11-text4": "Pending Approval",
    "page11-text5": "Active",
    "page11-text6": "Expired / Archived",
    "page11-text7": "Package name",
    "page11-text8": "Description",
    "page11-text9": "Create by",
    "page11-text10": "Create time",
    "page11-text11": "Status",
    "page11-text12": "Latest",
    "page11-text13": "Release",
    "page11-text14": "Version",
    "page11-text15": "module",
    "page11-text16": "index",

    "page12-text1": "Select...",

    "page13-text1": "Version",
    "page13-text2": "Question Type",
    "page13-text3": "Question Title (Chinese)",
    "page13-text4": "Question Title (English)",
    "page13-text4a": "Question No.",
    "page13-text4b": "e.g. BEE-A-01",
    "page13-text5": "Short Title (Chinese)",
    "page13-text6": "Short Title (English)",
    "page13-text7": "Reference (Chinese)",
    "page13-text8": "Reference (English)",
    "page13-text9": "Type",
    "page13-text11": "Is Comment",
    "page13-text12": "Label (Chinese)",
    "page13-text13": "Label (English)",
    "page13-text14": "Weight Percent",
    "page13-text15": "Order Num",
    "page13-text16": "Radio",
    "page13-text17": "Checkbox",
    "page13-text18": "Text",
    "page13-text19": "Board Effectiveness",
    "page13-text20": "Rating",

    "page14-text1": "Question Management",
    "page14-text2": "Last modified by ",
    "page14-text3": " on ",
    "page14-text4": "Duplicate Module",
    "page14-text5": "Release Question",
    "page14-text6": "Unbind Question",
    "page14-text7": "All Evaluation Questions",
    "page14-text8": "Click \"Edit\" to manage questions",
    "page14-text9": "New Question",
    "page14-text10": "Add Question",
    "page14-text11": "Create New Client",
    "page14-text12": "Client Information",
    "page14-text13": "Edit Client",
    "page14-text14": "Category",
    "page14-text15": "Question text",
    "page14-text16": "Latest",
    "page14-text17": "Version",
    "page14-text18": "Preview",
    "page14-text19": "Please confirm that you want to save release this package？",
    "page14-text20": "Please confirm that you want to release this module？",
    "page14-text21": "Please confirm that you want to unbind this module？",

    "page15-text1": "Click \"Edit\" to manage questions",
    "page15-text2": "New Question",

    "page16-text1": "User Management",
    "page16-text2": "Manage internal and external user access across all engagements",
    "page16-text3": "Add User",
    "page16-text4": "All Users",
    "page16-text5": "Internal User",
    "page16-text6": "External User",
    "page16-text7": "Pending",
    "page16-text8": "Suspended",
    "page16-text9": "Add New User",
    "page16-text10": "Edit User",
    "page16-text11": "User Information",
    "page16-text12": "Nick Name",
    "page16-text13": "Username",
    "page16-text14": "Email",
    "page16-text15": "Title",
    "page16-text16": "Tenure (Since)",
    "page16-text17": "Role",
    "page16-text18": "Company",
    "page16-text19": "AgeBand",
    "page16-text20": "Reset Password",
    "page16-text21": "User",
    "page16-text22": "Role & level",
    "page16-text23": "Organization",
    "page16-text24": "Status",
    "page16-text25": "Engagement",
    "page16-text26": "Last active",
    "page16-text27": "Female",
    "page16-text28": "Male",
    "page16-text29": "This email address is already registered. Please use a different email.",

    "page17-text1": "Client Information",
    "page17-text2": "Engagement Partner",
    "page17-text3": "email protected",
    "page17-text4": "Engagement Manager",
    "page17-text5": "Company Secretary",
    "page17-text6": "KEY CONTACT",
    "page17-text7": "Engagement History",
    "page17-text8": "Fiscal Year",
    "page17-text9": "Status & Report",
    "page17-text10": "Service Package",
    "page17-text11": "Subscription",
    "page17-text12": "Service Fee",
    "page17-text13": "HKD ",
    "page17-text14": "Payment",
    "page17-text15": "Open",
    "page17-text16": "View Archive",
    "page17-text17": "Revoke",
    "page17-text18": "Please confirm that you want to revoke this data？",
    "page17-text19": "Paid",
    "page17-text20": "Unpaid",

    "page18-text1": "Review Set-up",
    "page18-text2": "Status Snapshot",
    "page18-text3": "Enhanced Documentation Review",
    "page18-text4": "Review Dashboard",
    "page18-text5": "Action Tracker",
    "page18-text6": "Report & Repository",

    "page18-text7": "Current",
    "page18-text8": "Prior",
    "page18-text9": "New Action",
    "page18-text10": "Domain...",
    "page18-text11": "Relevant Question (e.g. BEE-F-02)",
    "page18-text12": "Owner *",
    "page18-text13": "Observation Title",
    "page18-text14": "Short observation name...",
    "page18-text15": "Observation Details",
    "page18-text16": "Describe the observation, finding, or issue in detail...",
    "page18-text17": "Action Title",
    "page18-text18": "Short action name...",
    "page18-text19": "Action Details",
    "page18-text20": "Describe the recommended action, steps, and expected outcome...",
    "page18-text21": "Target Date",
    "page18-text22": "Status",
    "page18-text23": "Save Action",
    "page18-text24": "Total",
    "page18-text25": "Done",
    "page18-text26": "In Progress",
    "page18-text27": "At Risk",
    "page18-text28": "ID",
    "page18-text29": "Domain",
    "page18-text30": "Ref",
    "page18-text31": "Obs. Title",
    "page18-text32": "Observation",
    "page18-text33": "Action Title",
    "page18-text34": "Action",
    "page18-text35": "Owner",
    "page18-text36": "Target",
    "page18-text37": "Not Started",
    "page18-text38": "In Progress",
    "page18-text39": "Done",
    "page18-text40": "At Risk",

    "page18-text41": "Module",
    "page18-text42": "Provided: ",
    "page18-text43": "pts",
    "page18-text44": "Partially: ",
    "page18-text45": "Not Provided: ",
    "page18-text46": "out of ",
    "page18-text47": "Confirm Final Score",
    "page18-text48": "Provided",
    "page18-text49": "Evidence Repository",
    "page18-text50": "Reviewer Rating",
    "page18-text51": "Provided",
    "page18-text52": "Partially Provided",
    "page18-text53": "Not Provided",
    "page18-text54": "Comments",
    "page18-text55": "Reviewer notes...",
    "page18-text56": "Observation / Exception Identified?",
    "page18-text57": "Flag if there are gaps against HKEX requirements.",
    "page18-text58": "Gap Log",
    "page18-text59": "Total Gaps: ",
    "page18-text60": "Gap Ref No.",
    "page18-text61": "Gap Title",
    "page18-text62": "Short headline of the issue",
    "page18-text63": "Description",
    "page18-text64": "Detailed description...",
    "page18-text65": "Add",
    "page18-text66": "Score Confirmed",
    "page18-text67": "HKEX Enhanced Documentation Review",
    "page18-text68": "Comprehensive board governance evaluation covering 8 domains of HKEX Corporate Governance\n Code compliance and best practices.",
    "page18-text69": "Module",
    "page18-text70": "Regulatory Context",
    "page18-text71": "Suggested Documents to Review",
    "page18-text72": "Review Focus",
    "page18-text73": "Documentation & Gap Analysis",
    "page18-text74": "Evidence Repository",
    "page18-text75": "Documents Reviewed:",
    "page18-text76": "No",
    "page18-text77": "Yes",
    "page18-text78": "Click to upload",
    "page18-text79": " or drag and drop",
    "page18-text80": "Max ",
    "page18-text81": "Confirm removal of ",
    "page18-text82": "Currently, only 3 files can be selected. This time, ",
    "page18-text83": " files have been selected",
    "page18-text84": "You can only upload file under 10MB",
    "page18-text85": " upload successfully!",
    "page18-text86": "The file name is duplicated!",

    "page18-text87": "Strategic Outputs",
    "page18-text88": "Draft CG Disclosure",
    "page18-text89": "Paragraph-form CG Report.",
    "page18-text90": "Download",
    "page18-text91": "Performance Dashboard",
    "page18-text92": "Scores, maturity, alignment.",
    "page18-text93": "Action Plan Register",
    "page18-text94": "Findings with status.",
    "page18-text95": "Skills Matrix Output",
    "page18-text96": "Skills vs strategy.",
    "page18-text97": "Strategic Outputs",
    "page18-text98": "Source data for audit trail.",
    "page18-text99": "9 directors · Full disclosure",
    "page18-text100": "All modules · BEE/BSE/STK/360°/COM",

    "page18-text101": "Download Report",
    "page18-text102": "Section 1 — Executive Summary",
    "page18-text103": "This Review Report sets out the detailed findings of the Board Performance Review, supporting the Corporate Governance Disclosure provided separately. It is intended for internal board use.",
    "page18-text104": "percentile",
    "page18-text105": "among Deloitte BoardSight peers",
    "page18-text106": "Maturity Rating",
    "page18-text107": "Leading",
    "page18-text108": "Board priority",
    "page18-text109": "Sustain and benchmark",
    "page18-text110": "Maintain standards, share leading practices across committees, and reassess periodically against evolving regulatory expectations.",
    "page18-text111": "Strong",
    "page18-text112": "Refine and deepen",
    "page18-text113": "Maintain standards, share leading practices across committees, and reassess periodically against evolving regulatory expectations.",
    "page18-text114": "Effective",
    "page18-text115": "Build and advance",
    "page18-text116": "Leverage existing strengths for targeted enhancement, focusing on domains with the greatest potential for uplift.",
    "page18-text117": "Developing",
    "page18-text118": "Remediate with structure",
    "page18-text119": "Establish a time-bound remediation plan with clear ownership, defined deliverables, and regular board reporting.",
    "page18-text120": "Watchlist",
    "page18-text121": "Escalate and intervene",
    "page18-text122": "Initiate board-level review, engage independent advisory support, and implement a comprehensive remediation programme.",
    "page18-text123": "Each band carries a specific interpretation of governance quality and a corresponding board priority for the year ahead:",
    "page18-text124": "Band",
    "page18-text125": "Range",
    "page18-text126": "Definition",
    "page18-text127": "Board Priority",
    "page18-text128": "Conclusion and Recommended Next Steps",
    "page18-text128a": "Generate with AI",
    "page18-text128b": "Reset to default",
    "page18-text128c": "Generate an AI conclusion from the Review Dashboard results? The current conclusion text in the editor will be replaced. Remember to Save afterwards.",
    "page18-text128d": "Reset the conclusion to the original banding template? The current conclusion text in the editor will be replaced. Remember to Save afterwards.",
    "page18-text128e": "AI conclusion generated. Please review and Save.",
    "page18-text128f": "Conclusion reset to default template. Please review and Save.",
    "page18-text128g": "Instructions to AI",
    "page18-text129": "LEADING",
    "page18-text130": "Governance practices are embedded, well-documented, and aligned across board and stakeholder perspectives, in both structural compliance and behavioural effectiveness.",
    "page18-text131": "STRONG",
    "page18-text132": "Governance practices are well-established and operating at a high standard across the majority of assessment domains, with a clear culture of accountability and proactive oversight.",
    "page18-text133": "EFFECTIVE",
    "page18-text134": "Governance structures and processes are in place, functioning in accordance with core regulatory expectations, and supported by an evident commitment to transparency and board-level engagement.",
    "page18-text135": "DEVELOPING",
    "page18-text136": "Governance processes are partially implemented or inconsistently applied, with observable shortfalls against regulatory expectations and recognised standards of board effectiveness.",
    "page18-text137": "WATCHLIST",
    "page18-text138": "Fundamental weaknesses are present across multiple domains, with governance practices that are materially below regulatory expectations and recognised standards of board effectiveness.",
    "page18-text139": "Board Composition & Skills",
    "page18-text140": "Culture & Dynamics",
    "page18-text141": "Board Practices",
    "page18-text142": "Information Quality & Timeliness",
    "page18-text143": "Board Meetings",
    "page18-text144": "Compliance & Training",
    "page18-text145": "Risk Management & Internal Control",
    "page18-text146": "Stakeholder Engagement",
    "page18-text147": "Please confirm that you want to Submit Report?",

    "page18-text148": "Section 2 — Score Construction",
    "page18-text149": "BoardSight comprises the below modules. The overall score is built up from the weighted contribution of each completed module. Modules not purchased contribute zero to the maximum ceiling.",
    "page18-text150": "Module",
    "page18-text151": "Score",
    "page18-text152": "Prior",
    "page18-text153": "Gap %",
    "page18-text342": "Contributed Score",

    "page18-text154": "Section 3 — Module Scorecard",
    "page18-text155": "3.1 BEE and BSE Scorecard",
    "page18-text156": "The table below sets out the score for each of the eight assessment domains, comparing the evidence-based BEE score with the BSE self-evaluation, the gap between them, and the resulting alignment rating.",
    "page18-text157": "Domain",
    "page18-text158": "BEE",
    "page18-text159": "BSE",
    "page18-text160": "Alignment",
    "page18-text161": "Alignment Guidance",
    "page18-text162": "Aligned",
    "page18-text163": "Self-assessment well-supported by evidence.",
    "page18-text164": "Average variance",
    "page18-text165": "Worth reviewing the evidence record.",
    "page18-text166": "Material variance",
    "page18-text167": "Investigate underlying cause.",
    "page18-text343": "Aligned (<15%)",
    "page18-text344": "Average variance (15%–<30%)",
    "page18-text345": "Material variance (≥30%)",
    "page18-text168": "Legend & Formulae",
    "page18-text169": "Gap % ",
    "page18-text170": " = (BEE − BSE) ÷ max(BEE, BSE) × 100 ",
    "page18-text171": " = Current year − Prior year",
    "page18-text172": "3.2 Stakeholder Module",
    "page18-text173": "The Stakeholder Module gathered anonymous feedback from three respondent groups. Respondent counts and average Likert scores (1–5) are set out below.",
    "page18-text174": "Group",
    "page18-text175": "Participant No.",
    "page18-text176": "Avg (1–5)",
    "page18-text177": "Prior",
    "page18-text178": "  vs prior year",
    "page18-text179": "3.3 Director 360°",
    "page18-text180": "The Director 360° module captures anonymous peer assessment. Individual director scores are provided confidentially and are not disclosed in this report.",
    "page18-text181": "3.4 Committee Effectiveness Review",
    "page18-text182": "Each active board committee was assessed using a common 12-question framework. Committee-level averages are set out below.",
    "page18-text183": "Committee",
    "page18-text184": "3.5 Documentation Enhanced Review",
    "page18-text185": "The Documentation Enhanced Review was conducted independently by Deloitte. Each of the eight assessment domains was rated Provided, Partially Provided, or Not Provided based on the quality and completeness of supporting documentation.",
    "page18-text186": "Rating Definitions",
    "page18-text187": "Provided (1.25 pts)",
    "page18-text188": "— The company supplied a complete set of formally structured, internally consistent documents for this domain. The documents are self-standing: another reviewer working from the same set would reach the same BEE score conclusion without needing verbal clarification or supplementary correspondence.",
    "page18-text189": "Partially Provided (0.625 pts)",
    "page18-text190": "— The company supplied documents for this domain, but the set is incomplete, informal in structure, or relies substantially on supplementary context — such as email chains, verbal confirmation, or interview notes — to substantiate specific BEE scores. There is a meaningful gap between what the documents show on their face and what was scored.",
    "page18-text191": "Not Provided (0 pts)",
    "page18-text192": "— The company did not supply documents for this domain, or the documents supplied are materially incomplete such that no meaningful documentary verification of BEE scores is possible. No enhanced-review credit is awarded for this domain.",
    "page18-text193": "Status",
    "page18-text194": "Provided",
    "page18-text195": "Partially Provided",
    "page18-text196": "Not Provided",

    "page18-text197": "Section 4 — Question Highlights",
    "page18-text198": "This section lists the highest-rated and lowest-rated questions across all completed modules, providing a question-level view of strengths and areas worth attention.",
    "page18-text199": "4.1 Areas Highly Rated (≥ 4.25)",
    "page18-text200": "These represent the strongest areas of governance practice during the review period.",
    "page18-text201": "4.2 Areas Worth Attention (≤ 1.5)",
    "page18-text202": "These areas carry the highest priority for attention. Each represents a question where the practice is absent or has a specific identified gap.",
    "page18-text203": "Domain/Group",
    "page18-text204": "Name",
    "page18-text204a": "Ref",

    "page18-text205": "Section 5 — Open Text Responses",
    "page18-text206": "All open-text responses extracted verbatim from the BSE and Stakeholder modules. Responses are anonymised — no individual attribution. Displayed in full; no summarisation or theming applied.",

    "page18-text207": "  — Review Report",
    "page18-text208": " · ",
    "page18-text209": ".HK",
    "page18-text210": "Package: ",
    "page18-text211": "Review: ",
    "page18-text212": "Report: ",
    "page18-text213": "CONFIDENTIAL — FOR BOARD USE ONLY. This report supports the CG Disclosure Insert provided separately. It is not for publication.",
    "disclaimerReviewDashboard": "<p>The Company conducted a formal Board performance evaluation during the review period. The evaluation took the form of a self-assessment and/or peer review and was conducted internally by the Company, facilitated through a digital platform provided by the Firm.</p><p>The Firm's role was limited to providing the survey platform and does not extend to verifying, auditing, or independently assessing the accuracy, completeness, or reliability of any responses submitted. The results of the evaluation do not constitute an audit, assurance engagement, or independent assessment of the Board's performance, and should not be relied upon as such by any third party.</p><p>The reliability of the results is inherently dependent on the candour, diligence, and good faith of the individuals providing responses. As the evaluation is based on individual perceptions and subjective assessments, the results should be interpreted accordingly. The findings are intended solely for the Company's internal governance improvement purposes.</p>",
    "disclaimerQuestionnaire": "Disclaimer",

    "page18-text214": "Director",
    "page18-text215": "Is lead",
    "page18-text216": "Post",
    "page18-text217": "Nick Name",
    "page18-text218": "Username",
    "page18-text219": "Email",
    "page18-text220": "Title",
    "page18-text221": "Role",
    "page18-text222": "Gender",
    "page18-text223": "Age",
    "page18-text224": "Tenure (Since)",
    "page18-text225": "Yes",
    "page18-text226": "No",
    "page18-text227": "Female",
    "page18-text228": "Male",

    "page18-text229": "Participants & Module Assignment",
    "page18-text230": "Add Participants",
    "page18-text231": "Directors",
    "page18-text232": " Participants Loaded",
    "page18-text233": "Name",
    "page18-text234": "Cat.",
    "page18-text235": "Title",
    "page18-text236": "Gender",
    "page18-text237": "Age",
    "page18-text238": "Tenure (Since)",
    "page18-text239": "Non-Director Participants",
    "page18-text240": "Category",
    "page18-text241": "Email",
    "page18-text242": "Confirm Assignment",
    "page18-text243": "Please select module!",

    "page18-text244": "Setup Progress",
    "page18-text245": " Ready",
    "page18-text246": "Save Draft",
    "page18-text247": "Launch Review",
    "page18-text248": " Need Guidance?",
    "page18-text249": "For questions regarding module configuration or technical issues, please refer to the SOP or contact our general inquiry desk.",
    "page18-text250": "View SOP Documentation",
    "page18-text251": "Contact Support Team",
    "availableSoon": "Available Soon",
    "page18-text252": "Participants & Roles",
    "page18-text253": "Schedule & Email",

    "page18-text254": "Description & Tips",
    "page18-text255": "Description",
    "page18-text256": "Reset to Default",
    "page18-text257": "Tips",
    "page18-text258": "Reset to Default",
    "page18-text259": "Schedule & Distribution",
    "page18-text260": "Launch Date",
    "page18-text261": "Deadline",
    "page18-text262": "Auto-Reminders",
    "page18-text263": "On Launch",
    "page18-text264": "Midpoint",
    "page18-text265": "3 Days Before",
    "page18-text266": "Invitation Email Preview",
    "page18-text267": "Insert data",
    "page18-text268": "Reset to Default",
    "page18-text269": "Title",
    "page18-text270": "Preview & Send Test",
    "page18-text271": "Confirm Schedule",
    "page18-text272": "Please complete input!",

    "page18-text273": " Package & Module Configuration",
    "page18-text274": "Note:",
    "page18-text275": " These modules have been assigned based on your engagement letter with Deloitte. If you believe there is a discrepancy, please contact your Deloitte engagement team before confirming.",
    "page18-text276": "Selected Package",
    "page18-text277": "Included Modules",

    "page18-text278": "Participant",
    "page18-text279": "Status",

    "page18-text280": "Progress Snapshot",
    "page18-text281": "Real-time completion status.",
    "page18-text282": "By Module",
    "page18-text283": "By Participant",
    "page18-text284": "Participant",
    "page18-text285": "Overall Status",
    "page18-text286": "Module Breakdown (1-8)",

    "page18-text287": "Recent Audit Trail",
    "page18-text288": "Time",
    "page18-text289": "User",
    "page18-text290": "Role",
    "page18-text291": "Action",
    "page18-text292": "Details",

    "page18-text293": "Total modules subscribed.",
    "page18-text294": " Days",
    "page18-text294-singular": " Day",
    "page18-text295": "Start: ",
    "page18-text296": "End: ",
    "page18-text297": "Total Modules",
    "page18-text298": "Total modules subscribed.",
    "page18-text299": "Participants",
    "page18-text300": "No. of unique participants.",
    "page18-text301": "Response Rate",
    "page18-text302": "Total submitted / Total requested.",
    "page18-text303": "Confirm File Upload",
    "page18-text304": "Are you sure all files have been uploaded?",
    "page18-text305": "Skip upload",
    "page18-text306": "Do not skip uploading",
    "page18-text307": "Time Left",
    "page18-text308": "SUM",
    "page18-text309": "Input Data",
    "page18-text310": "Admin Controls",
    "page18-text311": "Manage the lifecycle of this evaluation.",
    "page18-text312": "Send Reminder",
    "page18-text313": "Extend Deadline",
    "page18-text314": "End Evaluation",
    "page18-text314a": "Reopen Evaluation",
    "page18-text314b": "Questionnaire in progress",
    "page18-text314c": "Questionnaire closed",
    "page18-text315": "Please confirm that you want to send reminder?",
    "page18-text316": "Please confirm that you want to end evaluation?",
    "page18-text316a": "Please confirm that you want to reopen the evaluation?",
    "page18-text317": "File upload is not allowed in the current status",
    "page18-text318": "No documents uploaded",
    "page18-text319": "Pending launch",
    "page18-text320": "Assessment in progress",
    "page18-text321": "Review in progress",
    "page18-text322": "Pending final review",
    "page18-text323": "Report generated",
    "page18-text324": "Completed",
    "page18-text325": "Pending",
    "page18-text326": "Company Name",
    "page18-text327": "Survey Link",
    "page18-text328": "Deadline",
    "page18-text329": "Login Email",
    "page18-text329": "No areas highly rated have been noticed.",
    "page18-text330": "No areas worth attention (≤ 1.5) have been noticed.",
    "page18-text331": "Please confirm that you want to launch this review?",
    "page18-text332": "The review has been launched successfully.",
    "page18-text333": "Submit and Complete",
    "page18-text334": "Question No.",
    "page18-text335": "Client Administrator",
    "page18-text336": "Add Admin",
    "page18-text337": "No client administrator has been added for this company yet. Please add a client admin.",
    "page18-text338": "Add Client Admin",
    "page18-text339": "Name",
    "page18-text340": "Remove this participant?",
    "page18-text341": "Participant removed",
    "fileNotAvailableYet": "File is not available yet",

    "page19-text1": "Submission Deadline: ",
    "page19-text2": "Key Information",
    "page19-text3": "Deadline: ",
    "page19-text4": "Overall Progress",
    "page19-text5": "Your Assigned Modules",
    "page19-text6": "Not Started",
    "page19-text7": "Started",
    "page19-text8": "Complete",
    "page19-text9": " min",
    "page19-text10": "Start ",
    "page19-text11": "View ",
    "page19-text12": "Submitted",
    "page19-text13": "Not submitted",

    "page20-text1": "Engagement Management",
    "page20-text2": "Company",
    "page20-text3": "Fiscal Year",
    "page20-text4": "Service Package",
    "page20-text5": "Open",
    "page20-text6": "View",
    "page20-text7": "Status",
    "page20-text8": "Pending Launch",
    "page20-text9": "In Progress",
    "page20-text10": "Closed",

    "page21-text1": "Questions",
    "page21-text2": "Completed: ",
    "page21-text3": "Back to Home",
    "page21-text4": "Status",
    "page21-text5": "Not Started",
    "page21-text6": "In Progress",
    "page21-text7": "Complete",
    "page21-text8": "Time estimate",
    "page21-text9": " min",
    "page21-text10": "Progress",
    "page21-text11": "Auto-save",
    "page21-text12": "Saved",
    "page21-text13": "Select committees",
    "page21-text14": "Select your respondent group",
    "page21-text15": "Select directors to evaluate",
    "page21-text16": "Continue",
    "page21-text17": "Please complete the form",
    "page21-text18": "Please complete every module",
    "page21-text18a": "Please complete: {modules}",
    "page21-text19": "Reference: ",
    "page21-text20": "Add comment",
    "page21-text21": "Please confirm that you want to submit your questionnaire? You will not be able to edit answers after submission.",

    "engagement_management_text1": "Client Information",
};
